import { useTable } from "react-table";
import { useMemo, useState } from "react";
import primaryComponents from "../../primaryComponents";
import { defaultDateDisplay } from "../../../helpers";

const useExpenseCategoryTable = ({ expenseCategories }) => {
  const [isEditCategory, setIsEditCategory] = useState(false);
  const [isDeleteCategory, setIsDeleteCategory] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState({});
  const columns = useMemo(
    () => [
      {
        Header: "Category Name",
        accessor: "name",
      },
      {
        Header: "Created On",
        accessor: "created_at",
        Cell: ({ cell: { value } }) =>
          value ? defaultDateDisplay(value) : "N/A",
      },
      {
        Header: "Last Update On",
        accessor: "update_at",
        Cell: ({ cell: { value } }) =>
          value ? defaultDateDisplay(value) : "N/A",
      },
      {
        Header: "Action",
        Cell: ({ row }) => (
          <span className="d-flex align-items-center" style={{ gap: "10px" }}>
            <primaryComponents.Button
              classNames={"btn btn--primary smallBtn"}
              onClick={() => {
                setSelectedCategory(row?.original);
                setIsEditCategory(true);
              }}
            >
              Update
            </primaryComponents.Button>
            <primaryComponents.Button
              onClick={() => {
                setSelectedCategory(row?.original);
                setIsDeleteCategory(true);
              }}
              classNames={"btn btn--outline-red smallBtn"}
            >
              Delete
            </primaryComponents.Button>
          </span>
        ),
      },
    ],
    [],
  );

  const instance = useTable({ columns, data: expenseCategories });
  return {
    instance,
    selectedCategory,
    isDeleteCategory,
    isEditCategory,
    setIsDeleteCategory,
    setIsEditCategory,
    setSelectedCategory,
  };
};

export default useExpenseCategoryTable;
